"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logoutSuccess = exports.logoutRequest = exports.checkAccessTokenBySchedule = exports.invalidToken = exports.refreshTokenFail = exports.refreshTokenSuccess = exports.refreshTokenRequest = exports.updateUserInfoFields = exports.updateToken = exports.authFailed = exports.authComplete = void 0;

var _reduxAct = require("redux-act");

var PREFIX = 'COMMON/AUTH';
var authComplete = (0, _reduxAct.createAction)("".concat(PREFIX, "/AUTH_COMPLETE"));
exports.authComplete = authComplete;
var authFailed = (0, _reduxAct.createAction)("".concat(PREFIX, "/AUTH_FAILED"));
exports.authFailed = authFailed;
var updateToken = (0, _reduxAct.createAction)("".concat(PREFIX, "/UPDATE_TOKEN"));
exports.updateToken = updateToken;
var updateUserInfoFields = (0, _reduxAct.createAction)("".concat(PREFIX, "/UPDATE_USER_FIELDS")); // Refresh token actions

exports.updateUserInfoFields = updateUserInfoFields;
var refreshTokenRequest = (0, _reduxAct.createAction)("".concat(PREFIX, "/REFRESH_TOKEN.REQUEST"));
exports.refreshTokenRequest = refreshTokenRequest;
var refreshTokenSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/REFRESH_TOKEN.SUCCESS"));
exports.refreshTokenSuccess = refreshTokenSuccess;
var refreshTokenFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/REFRESH_TOKEN.FAIL"));
exports.refreshTokenFail = refreshTokenFail;
var invalidToken = (0, _reduxAct.createAction)("".concat(PREFIX, "/INVALID_TOKEN"));
exports.invalidToken = invalidToken;
var checkAccessTokenBySchedule = (0, _reduxAct.createAction)("".concat(PREFIX, "/UPDATE_ACCESS_TOKEN_SCHEDULE")); // Logout actions

exports.checkAccessTokenBySchedule = checkAccessTokenBySchedule;
var logoutRequest = (0, _reduxAct.createAction)("".concat(PREFIX, "/LOGOUT.REQUEST"));
exports.logoutRequest = logoutRequest;
var logoutSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/LOGOUT.SUCCESS"));
exports.logoutSuccess = logoutSuccess;